export const RESET_MODULE_ACTION = 'async-module/reset';
